import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={{
      borderTop: '1px solid var(--border-light)',
      background: 'var(--bg-secondary)',
      padding: '32px 24px',
      marginTop: 40
    }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <div style={{ display: 'flex', gap: 40, flexWrap: 'wrap', marginBottom: 24 }}>
          <div>
            <div style={{ fontSize: 18, fontWeight: 600, color: 'var(--text)', marginBottom: 8 }}>
              homes<span style={{ color: 'var(--blue)' }}>4bid</span>
            </div>
            <div style={{ fontSize: 12, color: 'var(--text-tertiary)', maxWidth: 220, lineHeight: 1.7 }}>
              The first two-sided marketplace for bidding on any home — listed or not.
            </div>
          </div>
          <div style={{ display: 'flex', gap: 40, flexWrap: 'wrap' }}>
            <div>
              <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 10 }}>Buyers</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 7 }}>
                <Link to="/search" style={{ fontSize: 12, color: 'var(--text-secondary)' }}>Search homes</Link>
                <Link to="/buyer-dashboard" style={{ fontSize: 12, color: 'var(--text-secondary)' }}>My bids</Link>
                <Link to="/letter-service" style={{ fontSize: 12, color: 'var(--text-secondary)' }}>Letter service</Link>
              </div>
            </div>
            <div>
              <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 10 }}>Owners</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 7 }}>
                <Link to="/owner-list" style={{ fontSize: 12, color: 'var(--text-secondary)' }}>List my home</Link>
                <Link to="/owner-dashboard" style={{ fontSize: 12, color: 'var(--text-secondary)' }}>Owner dashboard</Link>
                <Link to="/next-steps" style={{ fontSize: 12, color: 'var(--text-secondary)' }}>Next steps guide</Link>
                <Link to="/faq" style={{ fontSize: 12, color: 'var(--text-secondary)' }}>Owner FAQ</Link>
              </div>
            </div>
            <div>
              <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 10 }}>Company</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 7 }}>
                <button style={{ fontSize: 12, color: 'var(--text-secondary)', background: 'none', border: 'none', cursor: 'pointer', padding: 0, textAlign: 'left' }}>About</button>
                <button style={{ fontSize: 12, color: 'var(--text-secondary)', background: 'none', border: 'none', cursor: 'pointer', padding: 0, textAlign: 'left' }}>Contact</button>
                <button style={{ fontSize: 12, color: 'var(--text-secondary)', background: 'none', border: 'none', cursor: 'pointer', padding: 0, textAlign: 'left' }}>Terms of Use</button>
                <button style={{ fontSize: 12, color: 'var(--text-secondary)', background: 'none', border: 'none', cursor: 'pointer', padding: 0, textAlign: 'left' }}>Privacy Policy</button>
              </div>
            </div>
          </div>
        </div>
        <div style={{ borderTop: '1px solid var(--border-light)', paddingTop: 16, fontSize: 11, color: 'var(--text-tertiary)', lineHeight: 1.8 }}>
          Homes4Bid, Inc. is not a licensed real estate broker, agent, escrow provider, or attorney. Nothing on this platform constitutes legal, financial, tax, or real estate advice. Real estate laws and requirements vary by state — always consult a licensed professional in your jurisdiction. Advertised providers have paid for placement. © 2026 Homes4Bid, Inc.
        </div>
      </div>
    </footer>
  );
}
